

export const LINK_TALARIA_MARKETING = 'https://shoptalaria.com/';